import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-wrap mt-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "rounded-md cursor-pointer flex items-center justify-center opacity-0 transition group-hover:opacity-100 bg-black bg-opacity-40 absolute top-0 left-0 bottom-0 right-0" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "text-xs text-gray-400"
}
const _hoisted_9 = { class: "rounded-md cursor-pointer flex items-center justify-center opacity-0 transition group-hover:opacity-100 bg-black bg-opacity-40 absolute top-0 left-0 bottom-0 right-0" }

import { Media } from '@/inbox/message';
import { downloadFile } from '@/utils';
import { Tooltip, SvgIcon } from '@/ui-kit';
import fileSize from 'filesize';


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaList',
  props: {
    media: null
  },
  setup(__props: any) {



function getSVG(extension: string) {
	const supportedExtenstions = [
		'pdf',
		'ai',
		'mp3',
		'mp4',
		'avi',
		'doc',
		'zip',
		'xlx',
		'txt',
		'psd',
		'ppt',
		'mkv'
	];

	return supportedExtenstions.includes(extension)
		? extension
		: 'file-icon';
}

function openImage(url: string) {
	window.open(url, '_blank');
}

return (_ctx: any,_cache: any) => {
  return (__props.media.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.media, (item, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              (
						item.mime_type.startsWith('image')
					)
                ? (_openBlock(), _createBlock(_unref(Tooltip), { key: 0 }, {
                    popper: _withCtx(() => [
                      _createTextVNode(" Open image in new tab ")
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "group relative h-20 w-20 rounded-md mr-2 mb-2",
                        onClick: ($event: any) => (
							openImage(item.original_url)
						)
                      }, [
                        _createElementVNode("img", {
                          class: "h-20 w-20 rounded-md cursor-pointer object-cover",
                          src: item.original_url
                        }, null, 8, _hoisted_4),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_unref(SvgIcon), {
                            class: "text-white h-6 w-6",
                            name: "external-link"
                          })
                        ])
                      ], 8, _hoisted_3)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(_unref(Tooltip), { key: 1 }, {
                    popper: _withCtx(() => [
                      _createTextVNode(" Download file ")
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "relative flex flex-col items-center justify-center group h-20 w-20 flex items-center border-2 border-solid rounded-md py-1 px-2 text-sm mr-2 mb-2",
                        onClick: ($event: any) => (
							_unref(downloadFile)(item.original_url)
						)
                      }, [
                        _createElementVNode("img", {
                          src: 
								require(`@/assets/images/${getSVG(
									item.extension
								)}.svg`)
							,
                          class: "h-8 w-8 mb-2"
                        }, null, 8, _hoisted_7),
                        (item.size)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(fileSize)(item.size)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_unref(SvgIcon), {
                            class: "text-white h-6 w-6",
                            name: "download"
                          })
                        ])
                      ], 8, _hoisted_6)
                    ]),
                    _: 2
                  }, 1024))
            ], 64))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})